import { useState } from "react";

const FORMBACKEND_EARLY_ACCESS = "https://www.formbackend.com/f/70cd44d9014d5930";

export default function EarlyAccessForm({
  testidPrefix = "cta",
  label = "Request early access",
  source = "site",
  fineprint = "No noise. Occasional letters from the house.",
}) {
  const [email, setEmail] = useState("");
  const redirect =
    typeof window !== "undefined"
      ? `${window.location.origin}/`
      : "/";

  return (
    <form
      data-testid={`${testidPrefix}-form`}
      action={FORMBACKEND_EARLY_ACCESS}
      method="POST"
      acceptCharset="UTF-8"
      className="w-full max-w-xl"
    >
      <input type="hidden" name="_redirect" value={redirect} />
      <input type="hidden" name="source" value={source} />
      <div className="flex flex-col md:flex-row md:items-end gap-4 md:border-b md:border-ink">
        <input
          data-testid={`${testidPrefix}-email-input`}
          type="email"
          name="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="your@email"
          className="input-line w-full border-b border-ink md:border-b-0"
          style={{ padding: "12px 0" }}
        />
        <button
          type="submit"
          data-testid={`${testidPrefix}-submit`}
          className="btn-ink whitespace-nowrap w-full md:w-auto"
        >
          {label}
        </button>
      </div>
      <p className="text-pencil text-xs mt-3 tracking-wide">{fineprint}</p>
    </form>
  );
}
